import EventOptionState from './schema/EventOptionState';
import { createStore } from 'satcheljs';
import '../mutators/discardEventOption';
import '../mutators/selectEventDuration';
import '../mutators/selectReminderDefaultTimeOption';

/*
    Creates store which reflects the current state of settings under event option
*/

export default createStore<EventOptionState>('EventOptions', {
    defaultReminderTime: null,
    defaultMeetingDuration: null,
});
